import React, { useContext, useState } from "react"
import Favorite, { FavoriteButton } from "../../../../components/FavoriteButton"
import AppContext from "../../../../shared/AppContext"
import { withRouter } from "react-router"
import BackButton from "./BackButton"
import MyFavoritesModal from "../../../../components/ResearchCanvas/MyfavoriteModal"
import ViewReportButton from "./ViewReportButton"
import ShareModel from "../../../../components/ShareModel"

const Navigation = (props) => {
  const { rendered, location, match, model } = props
  const [shareSlug, setShareSlug] = useState()

  const { trackEvent } = useContext(AppContext)

  const onShareClick = async () => {
    const bookmark = await window.report.bookmarksManager.capture()
    const url = new URL(window.location.href)
    url.searchParams.set("bookmark", bookmark.state)
    setShareSlug(url.pathname + url.search)
  }

  const renderModelDependentButtons = () => {
    if (!rendered || !window.report) {
      return null
    }

    return (
      <React.Fragment>
        <ViewReportButton product={model.product} from={location.pathname} />
        <ShareModel
          slug={shareSlug}
          modelName={model.displayName}
          onClick={onShareClick}
        />
        <Favorite
          location={location}
          onAddFavorite={() => {
            trackEvent("Added Favorite", {
              type: "BI Model",
              metadata: {
                slug: match.params.slug,
              },
            })
          }}
          bookmark={window.report.bookmarksManager}
          dataset={"TSIS"}
          favoriteType="MODEL"
          modelName={model.displayName}
          report={window.report}
          variables={{
            favoriteType: "REPORT",
          }}
          trackingLocation={"TSIS / BI Model"}
        >
          <FavoriteButton
            iconBeforeText={true}
            className="btn-favorite-solid-default model-nav-btn"
          />
        </Favorite>
      </React.Fragment>
    )
  }

  const query = new URLSearchParams(location.search)
  const back = query.get("back")

  return (
    <div className="model-nav">
      {back === "bundles" ? (
        <BackButton
          text="Back to Observatory Bundles"
          linkTo="/observatory-bundles"
          from={location.pathname}
        />
      ) : (
        <BackButton
          text="Back to Drill Down Search"
          linkTo="/drill-downs"
          from={location.pathname}
        />
      )}
      <div className="nav-btn-container">
        {renderModelDependentButtons()}
        <MyFavoritesModal
          className="model-nav-btn"
          trackingLocation={"Drill Downs / BI Model"}
        />
      </div>
    </div>
  )
}

export default withRouter(Navigation)
